
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSailingFilled as ObiVesselTypeSailingFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-sailing-filled.js';
 
 
 

 
 export const ObiVesselTypeSailingFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-sailing-filled',
   elementClass: ObiVesselTypeSailingFilledElement,
   events: {
     
   }
  });
 
 